/**
 * 시스템 공통 오버레이(네트워크 배너·에러 메시지박스·페이지이동 로딩)를 런타임에 주입한다.
 *
 * 왜 JS 주입인가:
 *   서버 HTML(소스보기)에 노출되지 않도록 마크업을 뷰(top-nav-old.blade.php)에서 제거하고,
 *   대신 여기서 <body> 끝에 append 한다. 스타일은 인라인이 아니라
 *   mobile/components/_network.scss · _system-ui.scss (→ dist/m.css) 로 분리돼 있다.
 *
 * 타이밍:
 *   app.js 의 $(document).ready 최상단에서 inject() 를 호출한다.
 *   → Bootstrap 의 Network.start()/Layout.showMemberStatusBanner() 등 소비자보다 먼저 실행돼
 *     대상 요소(#offline-network-banner, #member-status-banner 등)의 존재가 보장된다.
 *   모바일 전 페이지가 main.js 를 로드하므로 공통 적용된다.
 *
 * 적용 범위 — 모바일 전용:
 *   main.js 는 adm/p/b 등 전 사이트가 로드하지만, 이 요소들을 숨기는 스타일은 dist/m.css 에만 있다.
 *   그래서 모바일 외 사이트에 주입하면 display:none 이 안 걸려 배너 문구·로딩 스피너가 그대로 노출된다.
 *   소비자(Network.start() 등)도 Sites/Mobile/Bootstrap 뿐이므로 Mobile 페이지에서만 주입한다.
 */
export default class SystemUi {
    inject() {
        if (typeof document === 'undefined' || !document.body) return;
        if (document.body.dataset.pageType !== 'Mobile') return;

        // 요소별 멱등 주입 — 이미 존재하는 id(페이지 전용 변형: 예) 일지 캘린더의
        // 커스텀 #PageMoveLoading)는 건드리지 않고, 없는 것만 body 끝에 추가한다.
        const els = [
            ['offline-network-banner', '<div id="offline-network-banner" class="network-banner">⚠️ 오프라인 상태입니다. 인터넷 연결을 확인하세요.</div>'],
            ['slow-network-banner',    '<div id="slow-network-banner" class="network-banner">⚠️ 네트워크 속도가 느립니다. 로딩이 지연될 수 있습니다.</div>'],
            ['member-status-banner',   '<div id="member-status-banner" class="network-banner"></div>'],
            ['errmgshowbox',           '<div id="errmgshowbox">100%</div>'],
            // id 는 기존 코드(Alim/Diary 가 show/hide 시 참조)가 쓰던 이름을 유지한다. 이미지가 아니라
            // CSS 3점 인디케이터(.jb-spin)라 src 를 갈아끼울 필요가 없다.
            ['PageMoveLoading',        '<div id="PageMoveLoading"><div class="page-move-loading__inner"><span id="PageMoveLoadingImg" class="jb-spin"><i></i><i></i><i></i></span></div></div>'],
        ];

        const html = els.filter(([id]) => !document.getElementById(id)).map(([, markup]) => markup).join('');
        if (html) document.body.insertAdjacentHTML('beforeend', html);
    }
}
